/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2021
 * @format
 * @flow
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './EditSensorGroup.module.css';
import Button from '../../../../../components/Button';
import Checkbox from '../../../../../components/Checkbox';
import strings from '../../../../../globalization';

const EditSensorGroup = props => {
  const { sensorGroup, updateSensorGroup, closeEditSensorGroupPopup } = props;

  const [orderingEnabled, setOrderingEnabled] = useState(false);
  const [foodRunnerDisabled, setFoodRunnerDisabled] = useState(false);

  useEffect(() => {
    setOrderingEnabled(sensorGroup.enableTableOrder);
    setFoodRunnerDisabled(sensorGroup.disableFoodRunner);
  }, []);

  const onSave = () => {
    const payload = {
      id: sensorGroup.id,
      enableTableOrder: orderingEnabled,
      disableFoodRunner: foodRunnerDisabled,
    };
    updateSensorGroup && updateSensorGroup(payload);
  };

  return (
    <div className={styles.container}>
      <div className={styles.close} onClick={closeEditSensorGroupPopup}>X</div>
      <div className={styles.contentWrapper}>
        <span className={styles.labelTxt}>{strings.idCaps}:</span>
        <span className={styles.valueTxt}>{sensorGroup.id}</span>
      </div>
      <div className={styles.contentWrapper}>
        <span className={styles.labelTxt}>{strings.name}</span>
        <span className={styles.valueTxt}>{sensorGroup.name}</span>
      </div>
      <OrderCheckbox
        label={strings.orderingEnabled}
        value={orderingEnabled}
        onChange={e => setOrderingEnabled(e.target.checked)}
      />
      <OrderCheckbox
        label={strings.foodRunnerDisabled}
        value={foodRunnerDisabled}
        onChange={e => setFoodRunnerDisabled(e.target.checked)}
      />
      <Button className={styles.btnWrapper} onClick={onSave}>
        <span className={styles.btnTxt}>SAVE</span>
      </Button>
    </div>
  );
};

const OrderCheckbox = ({ label, value, onChange }) => {
  return (
    <div className={styles.contentWrapper}>
      <span className={styles.labelTxt}>{label}:</span>
      <div className={styles.checkboxWrapper}>
        <Checkbox checked={value} onChange={onChange} />
      </div>
    </div>
  );
};

export default EditSensorGroup;

EditSensorGroup.propTypes = {
  sensorGroup: PropTypes.object,
  updateSensorGroup: PropTypes.func,
  closeEditSensorGroupPopup: PropTypes.func,
};

EditSensorGroup.defaultProps = {
  sensorGroup: {},
  updateSensorGroup: () => { },
  closeEditSensorGroupPopup: () => { },
};
